module.exports = __webpack_public_path__ + "static/img/20.9b68645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/20.png
// module id = swhW
// module chunks = 35